import React from 'react';

class StorageLink extends React.Component {
  _isMounted = false;

  constructor(props) {
    super(props);
    this.state = {
      file: '',
      loading: false,
    };
  }

  getDownloadURL = () => {
    const { src, storage } = this.props;

    if (!src) {
      if (this._isMounted) {
        this.setState({ file: '', loading: false });
      }
      return;
    }

    if (typeof src === 'string' && (src.startsWith('http://') || src.startsWith('https://'))) {
      if (this._isMounted) {
        this.setState({ file: src, loading: false });
      }
      return;
    }

    if (storage) {
      if (this._isMounted) {
        this.setState({ loading: true });
      }
      storage
        .ref(src)
        .getDownloadURL()
        .then((url) => {
          if (this._isMounted) {
            this.setState({ file: url, loading: false });
          }
        })
        .catch((error) => {
          console.warn('StorageLink failed to get download URL for:', src, error);
          if (this._isMounted) {
            this.setState({ file: '', loading: false });
          }
        });
    } else {
      if (this._isMounted) {
        this.setState({ file: '', loading: false });
      }
    }
  };

  componentDidMount() {
    this._isMounted = true;
    this.getDownloadURL();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.src !== this.props.src || prevProps.storage !== this.props.storage) {
      this.getDownloadURL();
    }
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  handleClick = (e) => {
    if (!this.state.file) {
      e.preventDefault();
      if (!this.props.src) {
        alert('添付ファイルが登録されていません。');
      } else if (this.state.loading) {
        alert('ファイルを読み込み中です。少々お待ちください。');
      } else {
        alert('添付ファイルが見つかりません。');
      }
    }
  };

  render() {
    const { target, children } = this.props;
    const { file } = this.state;

    return (
      <a
        href={file || '#!'}
        target={file ? target : undefined}
        rel={file ? 'noopener noreferrer' : undefined}
        onClick={this.handleClick}
      >
        {children}
      </a>
    );
  }
}

StorageLink.defaultProps = {
  target: '_blank',
};

export default StorageLink;